import React from "react"
import PropTypes from "prop-types"

import {
  StyledContainer,
  StyledContentContainer,
  StyledIcon,
  StyledDuration,
  StyledDistance,
  StyledFirstLine,
} from "./DistanceLabel.styles"

const DistanceLabel = ({ duration, distance }) => {
  return (
    <StyledContainer>
      <StyledContentContainer>
        <StyledFirstLine>
          <StyledIcon icon="traffic" />
          <StyledDuration>{duration}</StyledDuration>
        </StyledFirstLine>

        <StyledDistance>{distance}</StyledDistance>
      </StyledContentContainer>
    </StyledContainer>
  )
}
DistanceLabel.propTypes = {
  duration: PropTypes.string.isRequired,
  distance: PropTypes.string.isRequired,
}
export default DistanceLabel
